import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/utils/cn';

const inputVariants = cva(
  'w-full min-w-0 rounded-md border border-input bg-background px-3 py-1 text-base file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-75 ease-in-out',
  {
    variants: {
      size: {
        lg: 'h-12',
        md: 'h-10',
        sm: 'h-9',
        xs: 'h-8',
        default: 'h-9',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
);

function Input({
  className,
  type,
  size,
  ...props
}: Omit<React.ComponentProps<'input'>, 'size'> & VariantProps<typeof inputVariants>) {
  return (
    <input
      className={cn(inputVariants({ size }), className)}
      data-slot="input"
      type={type}
      {...props}
    />
  );
}

export { Input };
